import styled from 'styled-components'

export const AirlineCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: #f7fafc;
  border-radius: 12px;
  text-decoration: none;
  color: #2d3748;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    border-color: #4299e1;
  }
`;

export const AirlineLogo = styled.img`
  width: 150px;
  height: 150px;
  object-fit: contain;
  margin-bottom: 12px;
  border-radius: 8px;
`;

export const AirlineName = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 4px;
  text-align: center;
`;

export const AirlineDesc = styled.div`
  font-size: 0.9rem;
  color: #718096;
  text-align: center;
`;